module.exports = require('./lib/utils.js'
  )


//////////////////
// WEBPACK FOOTER
// ./node_modules/glamor/utils.js
// module id = 1247
// module chunks = 0